<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext, getPreviousStepId } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_military_ship_designs', router)
}

const isOnCommandSection = computed(() => {
  return route.path.startsWith('/command/ship-designs')
})

const goToCommand = () => {
  router.push('/command/ship-designs')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/military.webm"
  >
    <template #text>
      <p class="pb-2">
        Ship designs are the blueprints that define the capabilities of your vessels.
      </p>
      <p class="pb-2">
        Once we have researched new engines, weapons etc we should apply them to a new design.
      </p>
      <p class="pb-2">
        These designs can then be build into ships on your planets.
      </p>
      <p class="pb-2">
        When you are ready to make a new design, come back to this page. The design builder will explain how to create your first design.
      </p>
      <p class="pb-2">
        For now, let's build some more colonizers, we have more planets to settle!
      </p>

    </template>

    <template #alerts>
      <Alert type="info">
        You don't need to create new designs now, come back here when you have researched faster engines.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnCommandSection" @click="goToCommand" class="mr-2">
        Go to Ship Designs
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Continue
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>